module.exports = __webpack_public_path__ + "img/blogs_layout2.a7c556d1.png";